import React, { useEffect, useRef, useState } from "react";

function useOverflowCheck({ dependency }) {
  const tagRef = useRef(null);
  const textRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (!textRef?.current) return;
      if (tagRef?.current) {
        setWidth(tagRef.current.clientWidth);
      }

      const { scrollWidth, clientWidth, scrollHeight, clientHeight } =
        textRef.current;
      setIsOverflowing(
        scrollWidth > clientWidth || scrollHeight > clientHeight
      );
    };

    // Delay overflow check until DOM is painted
    const timeout = setTimeout(checkOverflow, 0);
    window.addEventListener("resize", checkOverflow);

    // Clean up on unmount
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [dependency]);

  return { tagRef, textRef, width, isOverflowing };
}

export default useOverflowCheck;
